import { jsx as r } from "react/jsx-runtime";
import { I18nextProvider as t } from "react-i18next";
const e = ({ children: e2, instance: i }) => r(t, { i18n: i, children: e2 });
export {
  e as I18nProvider
};
//# sourceMappingURL=I18nProvider.js.map
